import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosConfig from '../../utils/axiosConfig';

export const resetAppointmentNotification = createAsyncThunk(
	'notification/resetAppointments',
	async (_, { rejectWithValue }) => {
		try {
			return true;
		} catch (error) {
			return rejectWithValue({
				error: error.response?.data?.message ?? error.message,
			});
		}
	},
);

export const fetchInAppUnreadCount = createAsyncThunk(
	'notification/fetchInAppUnreadCount',
	async (_, { rejectWithValue }) => {
		try {
			const { data } = await axiosConfig.get('/notifications/unread-count');
			return { count: data?.count ?? 0 };
		} catch (error) {
			return rejectWithValue({
				error: error.response?.data?.message ?? error.message,
			});
		}
	},
);

export const fetchInAppNotifications = createAsyncThunk(
	'notification/fetchInAppNotifications',
	async (params = {}, { rejectWithValue }) => {
		try {
			const search = new URLSearchParams();
			if (params.page) search.set('page', String(params.page));
			if (params.limit) search.set('limit', String(params.limit));
			if (params.unreadOnly) search.set('unreadOnly', 'true');
			const q = search.toString();
			const { data } = await axiosConfig.get(`/notifications${q ? `?${q}` : ''}`);
			return {
				items: data?.items ?? [],
				total: data?.total ?? 0,
				page: data?.page ?? 1,
				limit: data?.limit ?? 20,
			};
		} catch (error) {
			return rejectWithValue({
				error: error.response?.data?.message ?? error.message,
			});
		}
	},
);

export const markInAppNotificationRead = createAsyncThunk(
	'notification/markInAppRead',
	async (id, { dispatch, rejectWithValue }) => {
		try {
			const { data } = await axiosConfig.patch(`/notifications/${id}/read`);
			try {
				await dispatch(fetchInAppUnreadCount()).unwrap();
			} catch {
				/* ignore */
			}
			return data;
		} catch (error) {
			return rejectWithValue({
				error: error.response?.data?.message ?? error.message,
			});
		}
	},
);
